/* Coria · text care se scrie singur in campurile de cautare (telefon + calculator).
   Scrie si sterge pe rand cateva cautari populare in placeholder.
   Merge si cand campul e activ dar gol; se opreste cand clienta scrie ceva sau cand alt script (microfonul) schimba placeholder-ul.
   perf 18.10.2026: porneste abia dupa prima interactiune (nu in timpul incarcarii / Lighthouse), anima doar campurile vizibile pe ecran
   (IntersectionObserver, fara offsetWidth la fiecare litera) si se opreste dupa MAX_WORDS cuvinte pe vizita: inainte schimba
   placeholder-ul de 10-15 ori pe secunda la nesfarsit (recalculare de stil + lazysizes la fiecare schimbare). */
(function () {
  if (window.cfSearchTyping) return;
  window.cfSearchTyping = 1;
  if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var PRE = 'Cauta ';
  var TERMS = ['oja semipermanenta', 'rubber base', 'top coat', 'lampa UV/LED', 'cat eye', 'builder gel', 'polygel', 'freza electrica', 'nuanta preferata'];
  var SEL = 'input[type="search"]:not(.coria-choice-search):not([class*="filter"]), input[name="q"]'; /* doar cautarea magazinului, nu cautarile din selectorul de arome/nuante sau filtre */
  var state = new WeakMap();
  var MAX_WORDS = 3, words = 0;
  var io = window.IntersectionObserver ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { var s = state.get(e.target); if (!s) return; s.vis = e.isIntersecting; if (s.vis && !s.t) tick(e.target); });
  }) : null;

  function idle(inp, s) {
    return !inp.value && (io ? s.vis : inp.offsetWidth > 0);
  }

  function tick(inp) {
    var s = state.get(inp);
    if (!s) return;
    // alt script a schimbat textul (ex. „Te ascult...”): asteptam sa revina
    if (s.last !== null && inp.placeholder !== s.last) { s.t = setTimeout(function () { s.last = inp.placeholder === s.orig ? null : s.last; tick(inp); }, 800); return; }
    if (!idle(inp, s)) {
      if (s.last !== null && inp.value) { inp.placeholder = s.orig; s.last = inp.placeholder; }
      /* camp in afara ecranului: asteptam IntersectionObserver-ul, fara sondaj */
      if (io && !s.vis) { s.t = 0; return; }
      s.t = setTimeout(function () { tick(inp); }, 600);
      return;
    }
    if (words >= MAX_WORDS) { if (s.last !== null) { inp.placeholder = PRE + TERMS[s.i % TERMS.length]; s.last = null; } s.t = 0; return; }
    var word = TERMS[s.i % TERMS.length], delay;
    if (!s.del) {
      s.n++;
      if (s.n >= word.length) { s.n = word.length; s.del = true; delay = 1700; } else delay = 65 + Math.random() * 45;
    } else {
      s.n--;
      if (s.n <= 0) { s.n = 0; s.del = false; s.i++; words++; delay = 350; } else delay = 30;
    }
    inp.placeholder = PRE + word.slice(0, s.n);
    s.last = inp.placeholder;
    s.t = setTimeout(function () { tick(inp); }, delay);
  }

  function attach(inp) {
    if (state.has(inp)) return;
    var s = { orig: inp.placeholder || 'Cauta', i: Math.floor(Math.random() * TERMS.length), n: 0, del: false, last: null, t: 0, vis: !io };
    state.set(inp, s);
    inp.setAttribute('aria-label', inp.getAttribute('aria-label') || 'Cauta');
    if (io) io.observe(inp); else tick(inp);
  }

  function scan() { document.querySelectorAll(SEL).forEach(attach); }
  function start() {
    scan();
    new MutationObserver(function () { clearTimeout(start.m); start.m = setTimeout(scan, 300); })
      .observe(document.body, { childList: true, subtree: true });
  }
  /* doar dupa prima interactiune (atingere, derulare, tasta, mouse) */
  var EV = ['pointerdown', 'touchstart', 'keydown', 'wheel', 'mousemove'], pornit = false; /* fara 'scroll' (derulari programatice) */
  function go() {
    if (pornit) return; pornit = true;
    EV.forEach(function (e) { window.removeEventListener(e, go, true); });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  }
  EV.forEach(function (e) { window.addEventListener(e, go, { capture: true, passive: true }); });
})();
